import { useState } from "react";
import { ResponsiveSheetDialog } from "@shared/components/ResponsiveSheetDialog/ResponsiveSheetDialog";
import { ImportContactsCsvUploadStep } from "./ImportContactsCsvUploadStep";
import { ImportContactsCsvPreviewStep } from "./ImportContactsCsvPreviewStep";
import type { ParsedCsvRow } from "./csv-import-helpers";

type ImportContactsCsvDialogProps = {
  open: boolean;
  onClose: () => void;
  onImported?: () => void;
};

export const ImportContactsCsvDialog = ({
  open,
  onClose,
  onImported,
}: ImportContactsCsvDialogProps) => {
  const [rows, setRows] = useState<ParsedCsvRow[] | null>(null);

  return (
    <ResponsiveSheetDialog
      open={open}
      onClose={onClose}
      onExited={() => setRows(null)}
      title="Import contacts from CSV"
      maxWidth={rows ? "lg" : "md"}
      fullScreen={rows !== null}
    >
      {rows ? (
        <ImportContactsCsvPreviewStep
          parsedRows={rows}
          onCancel={onClose}
          onImported={onImported}
        />
      ) : (
        <ImportContactsCsvUploadStep onParsed={setRows} />
      )}
    </ResponsiveSheetDialog>
  );
};
